import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import EvRetrofit from "@/pages/ev-retrofit/page";
import Solutions from "@/pages/solutions/page";
import Technology from "@/pages/technology/page";
import Fleet from "@/pages/fleet/page";
import Projects from "@/pages/projects/page";
import Partners from "@/pages/partners/page";
import Faq from "@/pages/faq/page";
import Contact from "@/pages/contact/page";
import PrivacyPolicy from "@/pages/legal/privacy-policy/page";
import Terms from "@/pages/legal/terms/page";
import CookiePolicy from "@/pages/legal/cookie-policy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "about", element: <About /> },
      { path: "ev-retrofit", element: <EvRetrofit /> },
      { path: "solutions", element: <Solutions /> },
      { path: "technology", element: <Technology /> },
      { path: "fleet", element: <Fleet /> },
      { path: "projects", element: <Projects /> },
      { path: "partners", element: <Partners /> },
      { path: "faq", element: <Faq /> },
      { path: "contact", element: <Contact /> },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "terms", element: <Terms /> },
      { path: "cookie-policy", element: <CookiePolicy /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;